import CarritoCompras from "../components/CarritoCompras";
import Header from "../components/layout/Header";
import { useEffect, useState } from "react";
import { useTitle } from "../hooks/useTitle";
import portada from "../assets/portada.png";
import dashboard from "../assets/dashboard.png";
import inventory from "../assets/inventory.png";
import { useProductos } from "../hooks/useProductos";
import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, withStyles } from "@material-ui/core";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import TableFooter from '@material-ui/core/TableFooter';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { Link, useParams } from "react-router-dom";
import { routes } from "../helpers/Routes";


const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));






const useStyles2 = makeStyles({
    table: {
        minWidth: 500,
    },
});

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

const Pedidos = () => {

    const { ordenes, formatoCOP, getOrdenes } = useProductos();

    
    const rows = ordenes?.map(orden => createData(
        orden?.norden,
        formatoCOP.format(orden?.total),
        orden?.tax,
        orden?.tax_ico,
        orden?.tax_base,
        orden?.name,
        orden?.description,
        orden?.currency,
        orden?.country,
        orden?.telephone,
        orden?.productos,
        orden?.status,
        orden?.createdAt
    ));

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const classes = useStyles2();

    useEffect(() => {
        getOrdenes();
    }, []);

    const [openCart, setOpenCart] = useState(false);
    const title = `Bicicletas JAVA Colombia`;
    useTitle({ title });

    function createData(norden, total, tax, tax_ico, tax_base, name, description, currency, country, telephone, productos, status, createdAt) {
        return { norden, total, tax, tax_ico, tax_base, name, description, currency, country, telephone, productos, status, createdAt };
    }

    // Mapea las órdenes y crea una lista de datos formateados
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <div className="banner-productos">
                    <div className="portada">
                        <img src={portada} alt="Portada" />
                        <p>Mis Pedidos</p>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="info-contact">
                        <div style={{ width: "100%" }}>
                            <h1>Mis pedidos</h1>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: 20 }}>
                                <nav className="nav-lateral">
                                    <Link to={routes.pedidos} style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}><img src={inventory} width={20} />Pedidos</Link>
                                </nav>
                                <div style={{ background: "#2c2e2d", padding: 20, borderRadius: 3, width: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", outline: "none", margin: "20px 0" }}>
                                        <h2>Pedidos</h2>
                                    </div>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="custom pagination table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="right">N° Orden</TableCell>
                                                    <TableCell align="right">Total</TableCell>
                                                    <TableCell align="right">Nombre</TableCell>
                                                    <TableCell align="right">Description</TableCell>
                                                    <TableCell align="right">Modeda</TableCell>
                                                    <TableCell align="right">Pais</TableCell>
                                                    <TableCell align="right">Telefono</TableCell>
                                                    <TableCell align="right">Productos</TableCell>
                                                    <TableCell align="right">Estado</TableCell>
                                                    <TableCell align="right">Fecha</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(rowsPerPage > 0
                                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : rows
                                                ).map((row, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell component="th" scope="row">
                                                            {row?.norden}
                                                        </TableCell>
                                                        <TableCell align="right">{row?.total}</TableCell>
                                                        <TableCell align="right">{row?.name}</TableCell>
                                                        <TableCell align="right">{row?.description}</TableCell>
                                                        <TableCell align="right">{row?.currency}</TableCell>
                                                        <TableCell align="right">{row?.country}</TableCell>
                                                        <TableCell align="right">{row?.telephone}</TableCell>
                                                        <TableCell align="right">{row?.productos}</TableCell>
                                                        <TableCell align="right">{row?.status === 1 ? "Rechazada" : "Aceptada"}</TableCell>
                                                        <TableCell align="right">{new Date(row?.createdAt).toLocaleDateString()}</TableCell>
                                                    </TableRow>
                                                ))}

                                                {emptyRows > 0 && (
                                                    <TableRow style={{ height: 53 * emptyRows }}>
                                                        <TableCell colSpan={6} />
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                        colSpan={3}
                                                        count={rows.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        SelectProps={{
                                                            inputProps: { 'aria-label': 'rows per page' },
                                                            native: true,
                                                        }}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        ActionsComponent={TablePaginationActions}
                                                    />
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}

export default Pedidos;
